import { useQuery } from "@tanstack/vue-query";
import { type MaybeRef } from "@vueuse/core";
import { api } from "@/api";
import { type KeypadEvent, parseKeypadEvent } from "./keypadEvents";

export const KEYPAD_EVENTS_QUERY_KEY = "keypadEvents";

type KeypadEventFilters = Partial<{
  search: string;
  siteId: string | null;
  status: string | null;
  enteredAtFrom: Date | null;
  enteredAtTo: Date | null;
}>;

type KeypadEventQuery = KeypadEventFilters & PaginationQuery;

type KeypadEventResponse = Paginate<
  RecursivelyConvertDatesToStrings<KeypadEvent>[]
>;

const listKeypadEvents = async (query: KeypadEventQuery) => {
  const { body } = await api.get<KeypadEventResponse>("/keypad-events/", {
    query,
  });

  return {
    ...body,
    items: body.items.map((eventResponse) => parseKeypadEvent(eventResponse)),
  };
};

export const useKeypadEvents = (query: MaybeRef<KeypadEventQuery>) => {
  const { id: currentSiteId } = useCurrentSite();

  return useQuery({
    queryKey: [
      KEYPAD_EVENTS_QUERY_KEY,
      computed(() => ({
        siteId: currentSiteId.value,
        ...unref(query),
      })),
    ] as const,
    queryFn: ({ queryKey: [_prefix, query_] }) =>
      listKeypadEvents(unref(query_)),

    refetchIntervalInBackground: false,
    refetchInterval: 30 * 1000, // 30 seconds for events (more frequent)
  });
};
